'use strict';
var getKeys = require('../utils/get-keys');

/**
 *
 * @param {object} object
 * @param {object} source
 * @returns {*}
 */
module.exports = function assign(object, source) {
    var sourceIndex = 1,
        index,
        keys;

    while (source) {
        keys = getKeys(source);
        index = keys.length;

        while (index--) {
            object[keys[index]] = source[keys[index]];
        }

        sourceIndex++;
        source = arguments[sourceIndex];
    }

    return object;
};
